import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import {AboutPage} from './pages/AboutPage';
import { HomePage } from './pages/HomePage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import {TermsPage} from './pages/TermsPage';
import {ContactPage} from './pages/ContactPage';
import {FaqPage} from './pages/FaqPage';
import { Footer } from './components/Footer';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-of-service" element={<TermsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/faq" element={<FaqPage />} />
      </Routes>
      <Footer />
    </Router>
  );
}
